import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {RootState} from "../../store";
import {dismissPageOperationErrors} from "../../reducers/pageOperationErrors";
import {CustomToast} from "../node/toast/CustomToast";

export default function PageSaveErrorToast() {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const pageId = useSelector((state: RootState) => state.appStorage.pageId);
    const errors = useSelector((state: RootState) => state.pageOperationErrors[String(pageId)]);

    if (!errors?.save && !errors?.publish) return null;
    if (errors?.save === "403" || errors?.publish === "403") return null;

    return <CustomToast
        isShow={true}
        setShow={() => dispatch(dismissPageOperationErrors(Number(pageId)))}
        message={t("nav.SavePublishError", {defaultValue: "Could not save or publish your changes. Please try again. Do not close the editor until your changes are saved."})}
        background="bg-danger"
        autoHide={false}
        isShowOnMeQR={true}
    />;
}
